import join from 'join-classnames';
import styles from './header.css';

const headerTemplate = ({ desktopSidebarIsToggleable, customerName }) => `
<div class="${styles.header}">
  <button class="${join(styles.hamburger, desktopSidebarIsToggleable && styles.alwaysVisible)}">
  <svg width="16px" height="16px" viewBox="0 0 16 16" >
    <g>
      <path d="M15,7H1C0.4,7,0,7.4,0,8s0.4,1,1,1h14c0.6,0,1-0.4,1-1S15.6,7,15,7z"/>
      <path d="M15,1H1C0.4,1,0,1.4,0,2s0.4,1,1,1h14c0.6,0,1-0.4,1-1S15.6,1,15,1z"/>
      <path d="M15,13H1c-0.6,0-1,0.4-1,1s0.4,1,1,1h14c0.6,0,1-0.4,1-1S15.6,13,15,13z"/>
    </g>
  </svg>
  </button>
  <nav class="${styles.navigationMenu}" role="navigation">
    <a href='/' class="${styles.logoWrapper}" id='logolink'>
      <img id="${styles.logo}" alt="${customerName} logo">
    </a>
    <div id="page-links" class="${styles.pageLinksSection}"> </div>
    <div id="headerRightElements" class="${styles.rightElements}">
      <div id="giveWidget" class="${styles.giveWidgetContainer}"/>
    </div>
  </nav>
</div>
`;

export default headerTemplate;
